import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { MainGrid } from './MainGrid';

// template — DWR app shell. Grid 3-row (header / body / footer), sfondo paper.
// Vedi mockup .app-shell (dev-workspace/mockups/.../project/styles.css righe 138-145).
// Compone internamente <MainGrid> per il body (header + 2-col main+aside + footer).

interface AppShellProps {
  header?: ReactNode;
  main: ReactNode;
  aside?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function AppShell({ header, main, aside, footer, className }: AppShellProps) {
  return (
    <div className={cn('bg-paper grid min-h-screen grid-rows-[auto_1fr_auto]', className)}>
      {header}
      <MainGrid main={main} aside={aside} />
      {footer}
    </div>
  );
}
